import type { IconNode } from '../types';

/**
 * @name cactus
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNSA4djZhMiAyIDAgMCAwIDIgMmgyIiAvPgogIDxwYXRoIGQ9Ik0xNSAxNGgyYTIgMiAwIDAgMCAyLTJWNiIgLz4KICA8cGF0aCBkPSJNOSAyMlY1YTMgMyAwIDEgMSA2IDB2MTciIC8+CiAgPHBhdGggZD0iTTcgMjJoMTAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/cactus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cactus: IconNode = [
  ['path', { d: 'M5 8v6a2 2 0 0 0 2 2h2', key: '6jejdd' }],
  ['path', { d: 'M15 14h2a2 2 0 0 0 2-2V6', key: 'dgxr1s' }],
  ['path', { d: 'M9 22V5a3 3 0 1 1 6 0v17', key: '1xkivm' }],
  ['path', { d: 'M7 22h10', key: '10w4w3' }],
];

export default cactus;
